<template>
  <div>
    <v-app>
      <Notification />
      <v-app-bar app clipped-right color="primary" dark class="z-100">
        <router-link to="/maintenance/company-config">
          <v-icon class="mr-6">mdi-arrow-left</v-icon>
        </router-link>
        <v-toolbar-title>Payroll Access Control: {{companyName}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-layout>
          <v-flex>
            <div class="float-right ml-3 mr-3">
              <v-layout class="pt-0">
                <v-flex>
                  <v-avatar size="42" class="ma-1 mr-2 sae-img-border with-bg">
                    <img
                      :src="avatarUrl"
                      alt="Avatar"
                      onerror="this.onerror=null;this.src='/img/logo_initial_gradient.png'"
                    />
                  </v-avatar>
                </v-flex>
                <v-flex class="">
                  <p class="pa-0 ma-0 text-left bold">
                    <small>{{ userName | split }}</small>
                  </p>
                  <p class="pa-0 ma-0 text-left lowercase">
                    <small>{{ userEmail | split }}</small>
                  </p>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
      </v-app-bar>

      <v-main>
        <v-container>
          <v-tabs v-model="tab" grow>
            <v-tab class="bold capitalize">User Settings</v-tab>
            <v-tab class="bold capitalize">Access Control</v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <user-setting v-if="tab == 0"/>
            </v-tab-item>
            <v-tab-item>
              <access-control v-if="tab == 1"/>
            </v-tab-item>
          </v-tabs-items>
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>
<script>
import firebase from "firebase";
import Notification from './../../components/Notification.vue';
import UserSetting from './components/UserSetting.vue'
import AccessControl from './components/AccessControl.vue';

export default {
  components: { Notification, UserSetting, AccessControl },
  name: "PayrollAccessControll",
  data() {
    return {
      companyName: this.$store.getters.pGetData('companyName'),
      loadingOverlay: false,
      user: { avatar_url: '' },
      tab: 0,

      drawer: false,
      drawerRight: false
    };
  },
  methods: {
    addMargin(name = '') {
      return name.length <= 34 ? 'mt-4' : 'mt-2'
    },
  },
  computed: {
    avatarUrl() {
      return this.$store.state.user.avatar;
    },
    userName() {
      return this.$store.state.user_name;
    },
    userEmail() {
      return this.$store.state.user_email;
    },
  },
  async created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user.avatar_url =
          "https://storage.cloud.google.com/appsensi-dev.appspot.com/images/avatars/" +
          user.uid;
      }
    });
  }
};
</script>
<style scoped>
.lowercase {
  text-transform: lowercase !important;
}
.bold {
  font-weight: 700 !important;
}
.z-100 {
  z-index: 100;
}
</style>